import { z } from 'zod';

export const createTradeSchema = z.object({
  symbol: z.string().min(1, '请输入交易品种').max(20, '交易品种最多20个字符'),
  market: z.string().max(50, '市场名称最多50个字符').optional(),
  direction: z.enum(['long', 'short'], { message: '请选择交易方向' }),
  entry_price: z.number().positive('请输入有效的开仓价格'),
  exit_price: z.number().positive('请输入有效的平仓价格').optional(),
  quantity: z.number().positive('请输入有效的数量'),
  leverage: z.number().min(1, '杠杆至少为1').max(500, '杠杆最大为500').optional(),
  profit_loss: z.number().optional(),
  commission: z.number().min(0, '佣金不能为负').optional(),
  swap: z.number().optional(),
  open_time: z.string().min(1, '请选择开仓时间'),
  close_time: z.string().optional(),
  strategy: z.string().max(100, '策略名称最多100个字符').optional(),
  pre_trade_emotion: z.number().min(1).max(10).optional(),
  post_trade_emotion: z.number().min(1).max(10).optional(),
  is_impulsive: z.boolean().optional(),
  tags: z.array(z.string()).optional(),
  notes: z.string().max(1000, '备注最多1000个字符').optional(),
  checklist_id: z.preprocess((val) => (val === '' || Number.isNaN(val) ? undefined : val), z.number().optional()),
  quality_score: z.preprocess((val) => (val === '' || Number.isNaN(val) ? undefined : val), z.number().min(0).max(100).optional()),
  risk_amount: z.preprocess((val) => (val === '' || val === null || val === undefined || Number.isNaN(val) ? undefined : Number(val)), z.number().positive().optional()),
});

export const updateTradeSchema = createTradeSchema.partial().extend({
  post_trade_emotion: z.number().min(1).max(10).optional(),
  r_multiple: z.number().optional(),
});

export const closeTradeSchema = z.object({
  exit_price: z.number().positive('请输入有效的平仓价格'),
  close_time: z.string().min(1, '请选择平仓时间'),
  profit_loss: z.number(),
  post_trade_emotion: z.number().min(1).max(10).optional(),
  notes: z.string().max(1000, '备注最多1000个字符').optional(),
});

export const tradeFilterSchema = z.object({
  status: z.enum(['all', 'profit', 'loss', 'open', 'closed']).optional(),
  period: z.enum(['all', 'today', 'week', 'month', 'custom']).optional(),
  symbol: z.string().optional(),
  direction: z.enum(['long', 'short']).optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  search: z.string().optional(),
});

export type CreateTradeFormData = z.infer<typeof createTradeSchema>;
export type UpdateTradeFormData = z.infer<typeof updateTradeSchema>;
export type CloseTradeFormData = z.infer<typeof closeTradeSchema>;
export type TradeFilterFormData = z.infer<typeof tradeFilterSchema>;
